export default {
    //landingPage
    landingPageTabTitle: "Landing Page | powerdoc",

    //landingPageForm
    landingPageFormChannelSelect: "How would you like to get the document?", //"לאן לשלוח לך את המסמך?",
    landingPageFormAllowChannelTag1: "SMS",
    landingPageFormAllowChannelTag2: "Email", //"מייל",
    landingPageFormAllowChannelTag3: "Whatsapp", //"וואטסאפ",
    landingPageFormAutoEmailLabel: "Email to receive copy of the signed document", //"מייל לקבלת עותק המסמך החתום",
    landingPageFormBroswer: "Click on the button will open the document in new browser",// "בלחיצה על הכפתור המסמך יפתח בדפדפן"
    landingPageFormTarget1: "Beside to SMS", //"במקביל ל SMS",
    landingPageFormTarget2: "Beside to Email", //"במקביל למייל",
    landingPageFormTarget3: "Beside to Whatsapp", //"במקביל ל Whatsapp",
    landingPageFormChannelEmailLabel: "Email", //"מייל",
    landingPageFormChannelMobileLabel: "Mobile", //"נייד",
    landingPageFormPoweredBy: "Powered By ",

    fieldRequired: "Required", //"שדה חובה",
    ruleRequired: "Filling this field is required", //"חובה למלא שדה זה",
    ruleEmailAdd: "Please insert valid E-mail address", //"יש להקליד כתובת מייל חוקית",
    rulePhone: "Please write a valid Phone number", //"נא להזין מספר נייד חוקי",//*signup
    ruleLessThan: "There must be less than", //"חייבים להיות פחות מ",
    character: "characters", //"תווים",
    ruleAtLeast: "There must be more than", //"חייבים להיות לפחות",

    //appStatus
    appStatusImgSentSuccess: "/static/img/appStatus_Success.png",
    appStatusTitleSentSuccess: "Link Succesfully Generated", //"קישור למסמך נוצר בהצלחה",
    appStatusSubtitleSentSuccessPhone: "And sent via SMS", //"ונשלח אליך במסרון",
    appStatusSubtitleSentSuccessEmail: "And sent via Email", //"ונשלח אליך במייל",
    appStatusSubtitleSentSuccessBrowser: "And will be opened via browser", //"ומיד יפתח בדפדפן",
    appStatusThridTitleSentSuccessCurrentBroswer: "in the same tab", //"הקישור יפתח בחלון זה",
    appStatusThridTitleSentSuccessNewBroswer: "in new tab", //"הקישור יפתח בחלון חדש",
    appStatusImgGlobalError: "/static/img/appStatus_NotValid.png",
    appStatusTitleGlobalError: "The link is unavailable", //"הקישור לדף נחיתה אינו זמין",
    appStatusImgSentFailed: "/static/img/appStatus_Failure.png",
    appStatusTitleSentFailed: "Error", //"שגיאה",
    appStatusSubtitleSentFailed: "Error while generating link", //"שגיאה בתהליך יצירת הקישור למסמך",
    appStatusThirdTitleSentFailed: "you can return", //"ניתן לחזור אחורה",
    appStatusBackBtnSentFailed: "go back", //"חזרה למילוי הטופס",
    appStatusContactDetails: "You can Contact to", //"ניתן לפנות ל ",

    //error
    err4093010: "You might already received link to the document", //"ייתכן כי כבר נשלח אליך קישור למסמך",
    err4093011: "Temporary unavailable, please try again in few minutes", //"זמנית לא ניתן לקבל קישור למסמך, יש לנסות שנית עוד מספר דקות",
    err4093007: "Landing page is not valid, go back and fill it again", //"תוקף דף הנחיתה הסתיים, יש לחזור חזרה למילוי הטופס ולנסות שנית",
    err4093009: "Landing Page is not available", //"דף נחיתה אינו זמין",
    err4097002: "Landing Page is not available" //"דף נחיתה אינו זמין",


}